module.exports = __webpack_public_path__ + "img/male-defPic.03c41e28.png";